import { expenseType } from "data/constant/expense-type";

export const initialFilterState = () => {
  return {
    dateType: "shift",
    startDate: null,
    endDate: null,
    searchKey: "",
    searchType: "expenseId",
    order: "desc",
    type: {
      isSelectedAll: true,
      value: expenseType.map((option) => option.value),
    },
    page: 1,
    perPage: 10,
  };
};
